import Typography from '@mui/material/Typography';
import { drivelabels_v2 } from '@googleapis/drivelabels';
import SharedDialog from '../../../shared/shared-dialog';
import { Messages } from '../../../utils/message-constants';
import { hasDisabledLabel } from './label-delete';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

interface DeleteLabelsDialogProps {
  open: boolean;
  handleClose: () => void;
  labels: Label[];
  isPending: boolean;
  onConfirm: () => void;
}

export default function DeleteLabelsDialog({
  open,
  handleClose,
  labels,
  isPending,
  onConfirm,
}: DeleteLabelsDialogProps) {
  const count = labels.length;
  const isPermanent = hasDisabledLabel(labels);
  const name = labels[0]?.properties?.title;
  const hasFields = (labels[0]?.fields?.length ?? 0) > 0;

  return (
    <SharedDialog
      open={open}
      handleClose={handleClose}
      title={Messages.DriveLabels.DeleteTitle(count)}
      dialogContent={
        <Typography>
          {count > 1 ? (
            <>
              Delete <strong>{count}</strong> labels?
            </>
          ) : (
            <>
              {name ? <strong>{name}</strong> : 'This label'}{' '}
              {isPermanent
                ? Messages.DriveLabels.DeletePermanentRest
                : hasFields
                ? Messages.DriveLabels.DeleteDraftRest
                : Messages.DriveLabels.DeleteEmptyDraftRest}
            </>
          )}
        </Typography>
      }
      primaryButton={{
        title:
          count > 1
            ? Messages.DriveLabels.DeleteManyButton
            : isPermanent
            ? 'Delete Permanently'
            : 'Delete',
        color: 'error',
        action: onConfirm,
        loading: isPending,
        disabled: isPending,
      }}
    />
  );
}
